import { render, staticRenderFns } from "./EducationsRouter.vue?vue&type=template&id=d02c60d2"
import script from "./EducationsRouter.vue?vue&type=script&lang=js"
export * from "./EducationsRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports